// frontend/src/components/LoadingModal.tsx
/**
 * Reusable loading modal component for operations that take a few seconds.
 * 
 * Shows a centered spinner with a title and optional message.
 * Prevents user interaction while operation is in progress.
 */

import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';

interface LoadingModalProps {
  open: boolean;
  title: string;
  message?: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({
  open,
  title,
  message,
}) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={3}>
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          {message && (
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {message}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;



